<template>
    <ur-modal ref="recModal" noFoot title="음성 듣기" dragable @closed="resetModal">
      <div :class="audioPlayerCls">
        <audio ref="audioPlayerInRec" muted="false" oncontextmenu="return false" id = "audioInRec" @volumechange="onVolumeChange" @play = "onRecordPlay" @pause = "onRecordPause" controls :src="audioBlobUrl" type="audio/mpeg3" style="height:48px;" controlsList="nodownload noplaybackrate"/>
      </div>
      <div class="modal_footer">>
        <div class="btn_left">
          <ur-button @click="onRecordingDownload">음성 다운로드</ur-button>
          <ur-button @click="onTextDownload">텍스트 다운로드</ur-button>
        </div>
        <ur-button style="font-size : 16px" shape="hyperlink" primary @click="goConversationModal">자세히 보기</ur-button>
      </div>
      <aicc-conversation-modal ref="convModalInrec" :convDataset="convDataset"/>
    </ur-modal>
</template>

<script>
const TAG_REGEX = /(<([^>]+)>)/gi;

    export default {
        name: 'RecordingModal',
        props:{
          convDataset : {
            type : Object,
                default() {
                    return {};
                },
            }
        },
        data() {
          return {
            conversationDataAsk: {
              requestId: '',
              outcallId: '',        
            },
            conversationData: [],
            recordDataAsk: {
              sid: '',
            },
            audioBlobUrl: '',
            recordFilename: '',
            audioPlayerPaused: true,
            audioPlayerMuted: false,
          };
        },
        computed:{
          audioPlayerCls() {
            let clazz = ['audio_player'];
            this.audioPlayerPaused ? clazz.push('play') : clazz.push('pause');
            this.audioPlayerMuted ? clazz.push('muted') : clazz.push('unmuted');
            console.log(clazz);
            return clazz;
          },
        },
        methods:{
          onVolumeChange(){
            this.audioPlayerMuted = this.$refs['audioPlayerInRec'].muted;
          },
          onRecordPlay(){
            this.audioPlayerPaused = false;
          },
          onRecordPause(){
            this.audioPlayerPaused = true;
          },
          getRecordFile(){
            http.request(this.convDataset.pageid, 'DTS_AIC_00021', {
              responseType: 'blob',
              query: this.recordDataAsk,
            }).then((response) => {
              if(response.data.size > 0){
                this.recordFilename = response.headers['content-disposition'].split('filename=')[1].split(';')[0];
                this.audioBlobUrl = aiccUtils.fileDownload.getBlobUrl(response.data, 'audio/mpeg');
                this.$refs['audioPlayerInRec'].src = this.audioBlobUrl;
              }
            });
          },
          open() {
            this.getConversationData();
            this.$refs['recModal'].open();
          },
          resetModal(){
            this.recordDataAsk.sid = '';
            this.conversationDataAsk.requestId = '';
            this.conversationDataAsk.outcallId = '';
            this.resetAudio();
          },
          resetAudio() {
            var audioElementInRec = this.$refs['audioPlayerInRec'];
            audioElementInRec.pause();
            audioElementInRec.currentTime = 0;
            audioElementInRec.src = "";
            this.audioBlobUrl = "";
            audioElementInRec.load();
            this.audioPlayerPaused = true;
          },
          goConversationModal(){
            this.resetAudio();
            this.$refs['recModal'].close();
            this.$refs['convModalInrec'].open();
          },
          getConversationData(){
            console.log(this.convDataset);
            this.conversationDataAsk.requestId = this.convDataset.scheduleId;
            this.conversationDataAsk.outcallId = this.convDataset.itemIndex;
            console.log(this.conversationDataAsk);
            const orgData = [];
            var seq = 0;

            http.request(this.convDataset.pageid, 'DTS_AIC_00017', {
              query: this.conversationDataAsk,
            }).then((response) => {
              console.log(JSON.stringify(response.data));
              utils.forEach(response.data.list, obj => {
                if(obj.msgFlag === '3'){ return;} // session manager
                const objData = {
                  seq: seq++,
                  msgSeq: obj.msgSeq,
                  msgFlag: obj.msgFlag,
                  // 메시지 내 tag 제거
                  msg: obj.msg.replaceAll(TAG_REGEX, ''),
                  msgTime: aiccUtils.conversationDownload.changeTimeZoneAndFormat(obj.msgTime),
                  // msgTime: aiccUtils.conversationDownload.changeTimeZoneAndFormat(obj.msgTime, 'HH:mm:ss'),
                  sessionId : obj.sessionId,
                }
                orgData.push(objData);
              });
              
              this.conversationData = orgData;

              if(response.data.list.length > 0){
                this.recordDataAsk.sid = response.data.list[0].sessionId;
              }
            }).then(() => {
              this.getRecordFile();
            });
          },
          onTextDownload(){
            const sToday = utils.now('YYYYMMDDHHmmss');
            const sCsvName = `conv_history_${sToday}.csv`;

            var conversationDataParam = [];
            var convkey = this.convDataset.scheduleId+'_'+this.convDataset.itemIndex;
            conversationDataParam[convkey] = this.conversationData;
            var convDatasetParam = [];
            convDatasetParam.push(this.convDataset);
            let historyData = {
              pageId : 'RecordingModal',
              fileName : sCsvName,
              fileDetail : `Request ID : ${this.convDataset.scheduleId} / Outcall Id : ${this.convDataset.itemIndex}`,
            }
            // 다운로드 이력 남기기
            http.request(this.convDataset.pageid, 'DTS_AIZ_00001', {
              data: historyData,
            }).then((res) => {
              if (res.status === 200) {
                aiccUtils.conversationDownload.makeConversationFileWithData(sCsvName, convDatasetParam, conversationDataParam);
              } else {
                utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
              }
            });
          },
          onRecordingDownload(){
            if(this.audioBlobUrl.length <= 0){
              return;
            }
            let historyData = {
              pageId : 'RecordingModal',
              fileName : this.recordFilename,
              fileDetail : `Session ID : ${this.recordDataAsk.sid}`,
            }
            // 다운로드 이력 남기기
            http.request(this.convDataset.pageid, 'DTS_AIZ_00001', {
              data: historyData,
            }).then((res) => {
              if (res.status === 200) {
                aiccUtils.fileDownload.download(this.audioBlobUrl, this.recordFilename);
              } else {
                utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
              }
            });
          },
        }
    }
</script>